<template>
  <div>
    <div v-html="parsedContent"></div>
  </div>
</template>

<script>
import gql from "graphql-tag";

export default {
  props: ["content", "makeApolloQuery"],
  data() {
    return {
      attempts: {}
    };
  },
  computed: {
    parsedContent() {
      return this.assembleContent(
        this.tokenize(this.content).map(x => this.makeQuery(x))
      );
    }
  },
  mounted() {
    //See the explanation in action/Page.Vue
    if (!this.makeApolloQuery) {
      this.makeApolloQuery = this.$apollo.addSmartQuery;
    }
  },
  methods: {
    makeQuery(descriptor) {
      if (descriptor.literal) {
        return descriptor.literal;
      } else {
        let nattempts = this.incAttempts(descriptor.query);
        if (nattempts > 10) {
          return this.attempts[descriptor.query].result;
        }
        let q = this.parseQuery(descriptor.query);
        let result;
        this.makeApolloQuery(
          "parsed" +
            Math.random()
              .toString(36)
              .substring(7),
          {
            query: q.query,
            update(data) {
              result = q.getValue(data);
            }
          }
        );
        this.attempts[descriptor.query].result = result;
        return result;
      }
    },
    tokenize(content) {
      let parts = content.split(";");
      const findOccurences = /{\[.*\]}/;
      let result = [];

      parts.forEach(p => {
        let index = p.search(findOccurences);
        let prefix = p.slice(0, index);
        let suffix = p.slice(index, -1);
        if (index === -1) {
          prefix = p;
          suffix = "";
        }
        result.push({ literal: prefix });
        if (suffix != "") {
          result.push({ query: suffix });
        }
      });
      return result;
    },
    parseQuery(query) {
      function extractParams(params) {
        return params
          .map(param => param.name + ":" + extractSubParams(param.value))
          .join();
      }
      function extractFields(fields) {
        return fields.map(extractSubfields).join("\n");
      }
      function extractSubfields(value) {
        if (value.literal) {
          return value.literal;
        }
        return `${value.name}{
            ${value.fields.map(extractSubfields)}
        }`;
      }
      function extractSubParams(value) {
        if (value.literal) {
          return value.literal;
        }
        return `{
            ${extractParams(value.fields)}
        }`;
      }
      query = query.slice(2, -1);
      query = JSON.parse(query);
      const queryString = gql`query{
          ${query.name}(${extractParams(query.params)}){
              ${extractFields(query.fields)}
            }
          }
      `;
      return {
        query: queryString,
        getValue(result) {
          result = result[query.name];
          let parts = query.print.split(".");
          for (let part of parts) {
            result = result[part];
          }
          return result;
        }
      };
    },
    incAttempts(q) {
      if (!this.attempts[q]) {
        this.attempts[q] = { num: 0 };
      } else {
        this.attempts[q].num += 1;
      }
      return this.attempts[q].num;
    },
    assembleContent(parts) {
      return parts.join("");
    }
  }
};
</script>
